// https://stackoverflow.com/a/44635703/8160318

/**
 * Debounce primarily @HostListeners, similar to rxjs's `debounceTime`
 * but without the rxjs boilerplate.
 * @param delay
 */
export function debounce(delay: number = 250): MethodDecorator {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const timeoutKey = Symbol();

    const original = descriptor.value;

    descriptor.value = function (...args) {
      clearTimeout(this[timeoutKey]);
      this[timeoutKey] = setTimeout(() => original.apply(this, args), delay);
    };

    return descriptor;
  };
}